const PATH = '/node_modules/@tcc-online/assets/integrations';
const LOGOS = import.meta.glob(
    '/node_modules/@tcc-online/assets/integrations/*',
);
const EXTENSIONS = ['png', 'svg', 'webp'];

export default async function loadIntegrationAsset(iconName: string) {
    let loadedIcon = null;

    for (const ext of EXTENSIONS) {
        const path = `${PATH}/${iconName}.${ext}`;
        if (LOGOS[path]) {
            const iconModule = LOGOS[path];

            loadedIcon = (await iconModule()) as any;
        }
    }
    return loadedIcon;
}
